/**
 * Frontend mirror of the curated marketplace tag pool.
 *
 * Source of truth: packages/workflow-templates/tag-pool.js
 *
 * Two reasons we mirror instead of importing directly:
 *   1. frontend/ does NOT depend on @zibby/workflow-templates — adding
 *      it would pull every template's source + scripts into the CRA
 *      build for one array of 12 strings.
 *   2. CRA's webpack resolver doesn't reach across the workspace's
 *      packages/ dir cleanly without aliasing every chunk.
 *
 * Mirror discipline: when you edit one file, edit the other. A vitest/
 * jest assertion lives at frontend/src/pages/MarketplacePage/__tests__/
 * marketplace-tag-pool.test.js — it reads the canonical file via fs +
 * compares the arrays. CI fails the diff if they drift.
 *
 * Pool order = display order in the chip row. Keep these arrays
 * identical (string-by-string, in order).
 */

export const MARKETPLACE_TAG_POOL = Object.freeze([
  'Chatbot',
  'Code Review',
  'Testing',
  'On-call',
  'Bug Triage',
  'Incidents',
  'Notifications',
  'Reports',
  'AI Spend',
  'Cost Tracking',
  'Support',
  'Docs',
  'Onboarding',
  'Marketing',
]);

export const MARKETPLACE_TAG_SET = new Set(MARKETPLACE_TAG_POOL);

/**
 * Helper used by the chip row — given a count map { tag → count },
 * return [{ name, count }] in POOL ORDER (not alphabetical, not
 * frequency). Tags not in the pool (e.g. legacy DDB rows, the
 * "child-workflow" meta-tag) are dropped from the display. Tags in
 * the pool but absent from current data render with count 0 — caller
 * decides whether to hide those.
 */
export function orderFacetsByPool(counts) {
  return MARKETPLACE_TAG_POOL
    .map((name) => ({ name, count: counts.get(name) || 0 }))
    .filter((f) => f.count > 0);
}
